import { render, staticRenderFns } from "./HealthStation.vue?vue&type=template&id=71a75112&scoped=true&"
import script from "./HealthStation.vue?vue&type=script&lang=js&"
export * from "./HealthStation.vue?vue&type=script&lang=js&"
import style0 from "./HealthStation.vue?vue&type=style&index=0&id=71a75112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a75112",
  null
  
)

export default component.exports